export default __webpack_public_path__ + "static/media/sprite.655860f0.svg";